module.exports = __webpack_public_path__ + "media/images/mailers/welcome_email/welcome_phone_image-b971c3f38f853a9f73aab8300463d584.png";